import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { Header } from '@anytag/shared-molecules';
import { UserForm } from '@anytag/shared-organisms';
import { useCreateUser } from './hooks';

export const AddUser = () => {
  useUpdateDocumentTitle({ title: 'documentTitle.AddUser', appHeader: 'appHeader.Add User', href: '/user' });
  const { createUser } = useCreateUser();

  return (
    <div>
      <Header />
      <UserForm onSubmit={createUser} />
    </div>
  );
};
